import { render } from "./PriceTerms.vue?vue&type=template&id=4cbaeeef"
import script from "./PriceTerms.vue?vue&type=script&lang=js"
export * from "./PriceTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__